export const sparkedMarkerSelector = ({sparkedMarker}) => sparkedMarker